import {Flux} from '@nlabs/arkhamjs';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

import {App} from './App/App.js';
import './ui/styles.css';

await Flux.init({name: 'reaktor-managed'});
createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
